import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseUrl } from "@/helpers/fetch.helpers";
import { getJwtToken } from "@/helpers/storage.helpers";

export type ScheduleType = {
  display_as: string;
  type: string;
};

export type ScheduleProfilePoint = {
  Time: string;
  Value: number;
};

export type CreateScheduleRequest = {
  AssetID: string;
  Type: string;
  Profile: ScheduleProfilePoint[];
};

export const createPowerScheduleApi = createApi({
  reducerPath: "createPowerScheduleApi",
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl("/schedule-input/api/"),
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${getJwtToken()}`);
      return headers;
    },
  }),
  endpoints: (build) => ({
    getScheduledTypes: build.query<ScheduleType[], void>({
      query: () => "scheduletypes",
    }),
    createSchedule: build.mutation<void, CreateScheduleRequest>({
      query: (body) => ({
        url: "schedules",
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json, text/plain, */*",
        },
      }),
    }),
    deleteSchedule: build.mutation<void, string>({
      query: (id) => ({
        url: "schedules",
        method: "DELETE",
        params: {
          scheduleid: id,
        },
      }),
    }),
  }),
});

export const {
  useGetScheduledTypesQuery,
  useCreateScheduleMutation,
  useDeleteScheduleMutation,
} = createPowerScheduleApi;
